if (!customElements.get("frequently-bought")) {
  customElements.define(
    "frequently-bought",
    class FrequentlyBought extends HTMLElement {
      constructor() {
        super();

        this.forms = this.querySelectorAll("form"); // Collect all product forms
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector("[data-submit-all]"); // Single submit button
        this.submitButton.addEventListener("click", this.onSubmitAllHandler.bind(this));

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitAllHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.submitButton.querySelector(".loading__spinner")?.classList.remove("hidden");

        const items = Array.from(this.forms).map((form) => {
          const formData = new FormData(form);
          return {
            id: formData.get("id"),
            quantity: parseInt(formData.get("quantity") || 1),
          };
        });

        // Instead of using FormData, create a JSON object to send directly
        const requestBody = {
          items: items,
        };

        // If you need to add cart sections information, add it directly to the JSON body
        if (this.cart) {
          requestBody.sections = this.cart.getSectionsToRender().map((section) => section.id);
          requestBody.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        // Create a configuration for the fetch request
        const formConfig = fetchConfig("javascript");
        formConfig.headers["X-Requested-With"] = "XMLHttpRequest";
        formConfig.headers["Content-Type"] = "application/json";  // Set correct content type for JSON
        formConfig.body = JSON.stringify(requestBody); // Convert the object to JSON string

        // Now you can send the request with the correct data format
        fetch(routes.cart_add_url, formConfig)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              this.error = true;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: items.map((item) => item.id),
                cartData: response,
              });

              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error) this.submitButton.removeAttribute("aria-disabled");
              this.submitButton.querySelector(".loading__spinner")?.classList.add("hidden");
            }
            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => console.error(e));
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
